import { graphql, useStaticQuery } from "gatsby"

export const useAllTestimonials = (locale) => {
  const { allCosmicjsTestimonials } = useStaticQuery(graphql`
    query {
      allCosmicjsTestimonials {
        edges {
          node {
            id
            slug
            title
            locale
            type
            content
            metadata {
              testimonial_image {
                imgix_url
              }
              testimonial_subtitle
              testimonial_video_url
            }
          }
        }
      }
    }
  `)

  const allItems = allCosmicjsTestimonials.edges.map(({ node }, index) => ({
    key: index,
    ...node,
  }))

  if (!locale) {
    return allItems
  }

  return allItems.filter((item) => item.locale === locale)
                 .sort((a, b) => b.metadata.testimonial_subtitle.localeCompare(a.metadata.testimonial_subtitle))
}
